<template>
  <tg-layout>
    <template slot="header">
      <tg-search-tool @on-submit="handleSearch" :disabled="!searchName">
        <el-input
          :placeholder="$t('column.input_username')"
          v-model="searchName"
          class="tg-input input-search-username"
          size="small"
          clearable
        ></el-input>
      </tg-search-tool>

      <template v-if="showTopTable">
        <tg-table
          ref="topTable"
          :columns="topColumns"
          :proxy="topProxy"
          :fit="true"
          :tableHeight="145"
          class="page--top-table"
          :cell-class-name="parseCellClass"
          @cell-click="handleCellClick"
          @on-loaded="handleLoaded"
        >
          <template slot="userfullname" slot-scope="scope">
            <tg-user-full-name
              ref="userfullname"
              :row="scope.row"
              :column="scope.column"
            ></tg-user-full-name>
          </template>
          <template slot="directpush_count" slot-scope="scope">
            <span :class="{ 'as-link': scope.value > 0 }">
              {{ scope.formated }}
            </span>
          </template>
        </tg-table>
      </template>
    </template>
    <el-row
      v-if="showLoading"
      style="background: #fff;height: 100%"
      v-loading="showLoading"
      :element-loading-text="loadingLabel"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
    </el-row>
    <template v-if="showProfileTable">
      <tg-form-table
        :caption="profileTitle"
        :columns="profileColumns"
        :data="profileData"
        :fenceCol="2"
        :columnWidth="250"
      >
        <template slot="userfullname" slot-scope="scope">
          <tg-user-full-name
            :row="scope.row"
            :column="scope.column"
          ></tg-user-full-name>
        </template>
        <template slot="upper_users" slot-scope="scope">
          <tg-upper-user :data="scope.value"></tg-upper-user>
        </template>
        <template slot="privilege_status" slot-scope="scope">
          <span
            :class="{
              'text-red': scope.value == 0,
              'text-green': scope.value == 1,
            }"
          >
            <!-- blocked 的值是相反的 -->
            {{ $t("enum.blocked[" + (scope.value == 1 ? 0 : 1) + "]") }}
          </span>
        </template>
      </tg-form-table>
    </template>

    <template v-if="showDirectpushTable">
      <tg-table
        ref="directpushTable"
        :columns="directpushColumns"
        :proxy="directpushProxy"
        :fit="true"
        showPagination
        @sort-change="handleSortChange"
      >
        <template slot="header">
          {{ $t("component.label.directpush_member") }}
        </template>
        <template slot="userfullname" slot-scope="scope">
          <tg-user-full-name
            :row="scope.row"
            :column="scope.column"
          ></tg-user-full-name>
        </template>
        <template slot="level" slot-scope="scope">
          <template v-if="scope.row.is_member == 1">
            Lv.{{ scope.value }}
          </template>
          <template v-else>
            {{ $t("component.label.not_tg_business_member") }}
          </template>
        </template>
      </tg-table>
    </template>
    <template v-if="!showTopTable">
      <div class="tg-bg-white">
        <tg-nodata :isNeedSearch="!isSearch"></tg-nodata>
      </div>
    </template>
  </tg-layout>
</template>

<script>
import TgLayout from "@/layout/TgLayout";
import TgSearchTool from "@/components/tool/TgSearchTool";
import TgTable from "@/components/table/TgTable";
import TgUserFullName from "@/components/slot/TgUserFullName";
import TgNodata from "@/components/TgNodata";
import TgFormTable from "@/components/table/TgFormTable";
import TgUpperUser from "@/components/slot/TgUpperUser";

import apis from "@/apis";
const api = apis.tg_business.member.board;

export default {
  components: {
    TgLayout,
    TgSearchTool,
    TgTable,
    TgUserFullName,
    TgNodata,
    TgFormTable,
    TgUpperUser,
  },
  data() {
    return {
      searchName: "",
      showTopTable: false,
      topColumns: [],
      topProxy: api.getData,
      showProfileTable: false,
      profileColumns: [],
      profileData: {},
      showLoading: false,
      isSearch: false,
      target: {},
      showDirectpushTable: false,
      directpushColumns: [],
      directpushProxy: api.getDirectpush,
    };
  },
  computed: {
    loadingLabel() {
      return this.$t("component.table.loading");
    },
    profileTitle() {
      return this.showTopTable ? this.$refs.userfullname.$el.innerText : "";
    },
    request() {
      return {
        targetName: this.target.username,
      };
    },
  },
  created() {
    api.getColumns().then((response) => {
      this.topColumns = response.data.columns;
      this.profileColumns = response.data.profileColumns;
      this.directpushColumns = response.data.directpushColumns;
    });
  },
  methods: {
    handleSearch() {
      this.showTopTable = true;
      this.isSearch = true;
      this.showProfileTable = false;
      this.showDirectpushTable = false;

      this.$nextTick(() => {
        this.$refs.topTable.search({ targetName: this.searchName });
      });
    },
    handleLoaded(response) {
      if(response.retcode == 0){
        let hasData = response.data.length > 0;

        if (hasData) {
          this.target = response.data[0];
        }
        this.showTopTable = hasData;
      }
    },
    handleCellClick(row, column) {
      if (column.columnKey == "username") {
        this.showDirectpushTable = false;

        this.showLoading = true;
        api.getProfile(this.request).then((response) => {
          if(response.retcode == 0){
            this.profileData = response.data;
            this.showLoading = false;
            this.$nextTick(() => {
              this.showProfileTable = true;
            });
          }
        });
      } else if (column.columnKey == "directpush_count") {
        this.showProfileTable = false;
        this.showDirectpushTable = true;
        this.$nextTick(() => {
          this.$refs.directpushTable.search(this.request);
        });
      }
    },
    parseCellClass({ column }) {
      if (["username", "directpush_count"].indexOf(column.columnKey) > -1) {
        return "clickable text-primary";
      }
    },
    handleSortChange({ prop, order }) {
      let searchData = { ...this.request };
      searchData.sortField = prop;
      searchData.sortBy = order == "ascending" ? "asc" : "desc";
      this.$refs.directpushTable.search(searchData);
    },
  },
};
</script>
